import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { changeOrderColumns } from "./columns";
import { lightTable } from "../../../../../styles/muiProps";
import { useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { secondAxios } from "../../../../../api/axios";
import { updateCO } from "./api";

export default function CMSPage() {
  const { plantId } = useParams();

  const [tableData, setTableData] = useState([]);
  const [fabData, setFabData] = useState([]);

  async function getCOs() {
    const res = await secondAxios.get(`/change-order/plant/${plantId}`);
    const fabRes = await secondAxios.get(`/fabrication/plant/${plantId}`);

    const fabricationData = fabRes.data || [];

    const data = res.data.map((co) => {
      const currentDrawing = co.allDrawingsRevs.find(
        (d) => d.id === co.drawingId,
      );
      const previousDrawing = co.allDrawingsRevs?.find(
        (d) => Number(d.revision) === Number(currentDrawing.revision) - 1,
      );

      const materialsItems = co.materials?.map((m) => m.material.item);

      const previousMaterials =
        previousDrawing?.materials?.filter((pm) =>
          materialsItems?.includes(pm.item),
        ) || [];

      const est_bomTaggedMaterials =
        co.materials?.map((m) => m.tagNumbers || m.taggedMaterial?.tagNumber) ||
        [];
      const est_bulkMaterials =
        previousMaterials?.map(
          (m) =>
            `${m?.description || ""} - ${m?.length !== "-" ? m?.length + " Ft. - " : ""} ${m?.quantity || ""}`,
        ) || [];

      const actual_bomTaggedMaterials =
        co.materials?.map((m) => m.tagNumbers || m.taggedMaterial?.tagNumber) ||
        [];
      const actual_bomBulkMaterials =
        co.materials?.map(
          (m) =>
            `${m?.material?.description || ""} - ${m?.material?.length !== "-" ? m?.material?.length + " Ft. - " : ""} ${m?.material?.quantity || ""}`,
        ) || [];

      const isTagged =
        co.materials?.[0]?.tagNumbers ||
        co.materials?.[0]?.taggedMaterial?.tagNumber;

      const est_bom = isTagged ? est_bomTaggedMaterials : est_bulkMaterials;
      const actual_bom = isTagged
        ? actual_bomTaggedMaterials
        : actual_bomBulkMaterials;

      const materialsFabHours = co.materials?.map((m) => {
        return (
          fabricationData.find(
            (f) => f.materialDescription === m.material?.description,
          )?.actualhours || 0
        );
      });
      const actual_manhours =
        materialsFabHours?.reduce((a, b) => a + b, 0) || 0;

      let actual_materialsCost = 0;
      // console.log("row", previousMaterials);

      previousMaterials?.forEach((m) => {
        const cost = m?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost;
        if (cost) actual_materialsCost += Number(cost);
      });

      const actual_totalCost = actual_materialsCost || 0;

      const est_totalCost =
        Number(co.estMaterialCost) + Number(co.estOtherCost) || 0;

      const profit = est_totalCost - actual_totalCost;

      return {
        ...co,
        actual_bom,
        actual_manhours,
        actual_materialsCost,
        actual_totalCost,

        est_bom,
        est_totalCost,

        profit,
      };
    });

    // console.log("data co:", data);
    setTableData(data);
    setFabData(fabRes.data);
  }
  useEffect(() => {
    getCOs();
  }, []);

  const cols = useMemo(
    () =>
      changeOrderColumns({
        user: null,
        tableData,
        setTableData,
        fabData,
      }),
    [tableData],
  );

  // console.log("tableData", tableData?.[0]);
  const table = useMaterialReactTable({
    data: tableData,
    columns: cols,
    ...lightTable,

    enableEditing: true,
    editDisplayMode: "row",
    enableRowActions: true,
    positionActionsColumn: "last",

    // show Edit action per row
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Edit Est. Data + Responsible User">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    // commit ONLY allowed fields on save
    onEditingRowSave: async ({ row, values, table }) => {
      setTableData((prev) => {
        const next = [...prev];
        const oldRow = next[row.index];

        const editedKeys = [
          "estManhours",
          "estMaterialCost",
          "estOtherCost",
          "responsible",
        ];

        const editedData = Object.fromEntries(
          editedKeys.map((key) => [key, oldRow[key]]),
        );
        console.log("editedData", { ...editedData, id: oldRow.id });

        updateCO(oldRow.id, editedData);
        return next;
      });

      table.setEditingRow(null);
    },
  });

  return (
    <Box sx={{ p: 2 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 2,
        }}
      >
        <Typography variant="h5" sx={{ mb: 1, fontWeight: "bold" }}>
          Change Management System:
        </Typography>

        <Button
          //   onClick={handleAddRow}
          variant="contained"
          startIcon={<AddBoxIcon />}
        >
          Add New
        </Button>
      </Box>

      <div style={{ marginTop: "5px" }}>
        <MaterialReactTable table={table} />
      </div>
    </Box>
  );
}
